export default __webpack_public_path__ + "assets/e128f8e56ae05dc528e6abca2aaa51d7.jpg";